<!-- Note: This file is intentionally empty; the "Preview" module is a blank div. -->
<template>
  <div />
</template>

<script>
export default {
  name: 'PreviewModule',
};
</script>
